import { sanitizePositionSet } from "../helpers"

const FACTORS_SUBQUERY = `
  exposure (contentSetId: $contentSetId) {
    factors (category: $category) {
      id
      name
      category
      netContribution: net
      currencyExposure
    }
  }
`

function getQuery(shouldUseIntradayQuery) {
  if (shouldUseIntradayQuery) {
    return `query ($modelId: String!, $positionSet: PositionSetInput!, $contentSetId: String!, $category: [String], $batchId: Id, $on: Date!) {
        model (id: $modelId) {
          simulation: intradaySimulationBatch (positionSet: $positionSet, batchId: $batchId, on: $on) {
            ${FACTORS_SUBQUERY}
          }
        }
      }`
  }

  return `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $date: Date!, $contentSetId: String!, $category: [String]) {
    model (id: $modelId) {
      simulation (positionSet: $positionSet, base: $base, from: $date, to: $date, interval: END_DATE) {
        ${FACTORS_SUBQUERY}
      }
    }
  }`
}

function getFactorData(exposure, prefix) {
  if (!exposure) {
    return {}
  }
  return exposure.reduce((acc, factor) => {
    return {
      ...acc,
      [factor.id]: {
        label: factor.name || factor.id,
        category: factor.category,
        values: {
          [prefix]: {
            netContribution: factor.netContribution,
            currencyExposure: factor.currencyExposure,
          },
        },
      },
    }
  }, {})
}

export function createFactorContentSetQuery({ prefix, modelId, positionSet, base, to, contentSetId, ...options }) {
  const { selectedCategory, on, batchId, shouldUseIntradayQuery } = options

  let key = ["contentSet", "factors", prefix, modelId, positionSet, contentSetId, shouldUseIntradayQuery]
  let additionalVariables = {}

  if (shouldUseIntradayQuery) {
    key = [...key, batchId, on]
    additionalVariables = {
      on,
      batchId,
    }
  } else {
    key = [...key, base, to]
    additionalVariables = {
      base,
      date: to,
    }
  }

  return {
    prefix,
    key,
    query: getQuery(shouldUseIntradayQuery),
    variables: {
      modelId,
      positionSet: sanitizePositionSet(positionSet),
      contentSetId,
      category: selectedCategory,
      ...additionalVariables,
    },
    select: (result) => {
      const exposure = result.data.model.simulation.exposure?.[0]?.factors
      const factors = getFactorData(exposure, prefix)
      const category = options.category
      if (category && category !== "all") {
        const filteredFactors = Object.values(factors).filter((factor) => factor.category === category)
        return {
          label: category,
          children: filteredFactors,
        }
      }
      return {
        label: "Total",
        children: factors,
      }
    },
  }
}
